import RequestRoutes from './request.routes';

export default [
  ...RequestRoutes,
]
